import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AlumnoForm from './DetailsStudent/AlumnoForm';
import RegistroPracticas from './DetailsStudent/RegistroPracticas';
import SesionesAlumno from './DetailsStudent/SesionesAlumno';
import LecturasAlumno from './DetailsStudent/LecturasAlumno';
import ProgresoEvaluacionesAlumno from './DetailsStudent/ProgresoEvaluacionesAlumno';
import { Button, Container, Spinner } from 'react-bootstrap';
import { FaUser, FaClipboardList, FaBook, FaArrowLeft, FaFileAlt, FaGraduationCap, FaChartLine } from 'react-icons/fa';
import './DetalleAlumno.scss';

const DetalleAlumno = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('detalles');
  const [loading, setLoading] = useState(false);

  const tabs = [
    { id: 'detalles', label: 'Datos del Alumno', icon: <FaUser /> },
    { id: 'sesiones', label: 'Ficha del Alumno', icon: <FaFileAlt /> },
    { id: 'practicas', label: 'Registro de Prácticas', icon: <FaClipboardList /> },
    { id: 'lecturas', label: 'Lecturas Adicionales', icon: <FaBook /> },
    { id: 'progreso', label: 'Progreso de Evaluaciones', icon: <FaChartLine /> }
  ];

  // Efecto para manejar el estado de carga
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        // Aquí iría la lógica de carga de datos
        await new Promise(resolve => setTimeout(resolve, 500)); // Simulación de carga
      } catch (error) {
        console.error('Error al cargar datos:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Cargando información...</p>
        </div>
      );
    }

    switch (activeTab) {
      case 'detalles':
        return <AlumnoForm alumnoId={id} />;
      case 'practicas':
        return <RegistroPracticas alumnoId={id} />;
      case 'sesiones':
        return <SesionesAlumno alumnoId={id} />;
      case 'lecturas':
        return <LecturasAlumno id={id} />;
      case 'progreso':
        return <ProgresoEvaluacionesAlumno alumnoId={id} />;
      default:
        return <AlumnoForm alumnoId={id} />;
    }
  };

  return (
    <div className="detalle-alumno">
      <header className="detalle-alumno__navbar">
        <Container fluid className="detalle-alumno__navbar-container">
          <div className="detalle-alumno__heading-row">
            <h1 className="detalle-alumno__title">
              <FaGraduationCap aria-hidden="true" />
              <span>Detalles del Alumno</span>
            </h1>

            <Button
              type="button"
              variant="outline-primary"
              onClick={() => navigate(-1)}
              className="detalle-alumno__button--back btn-text-white-active"
            >
              <FaArrowLeft aria-hidden="true" />
              <span>Volver</span>
            </Button>
          </div>

          <nav className="detalle-alumno__tabs" aria-label="Secciones del alumno">
            {tabs.map((tab) => (
              <Button
                type="button"
                key={tab.id}
                variant={activeTab === tab.id ? 'primary' : 'outline-primary'}
                onClick={() => setActiveTab(tab.id)}
                className="detalle-alumno__tab btn-text-white-active"
                aria-pressed={activeTab === tab.id}
              >
                <span className="detalle-alumno__tab-icon" aria-hidden="true">
                  {tab.icon}
                </span>
                <span>{tab.label}</span>
              </Button>
            ))}
          </nav>
        </Container>
      </header>

      <Container fluid className="detalle-alumno__container">
        <div className="detalle-alumno__surface">
          <div className="detalle-alumno__content">
            {renderContent()}
          </div>
        </div>
      </Container>
    </div>
  );
};

export { DetalleAlumno };
